import axios from "axios";

export const HTTP = axios.create({
  baseURL: "//www.senat.fr/calendrier_activite/json/"
});



// WEBPACK FOOTER //
// ./src/axios.js